import Compressor from 'compressorjs'
export default (image) => {
    return new Promise(resolve => {
        const _compressor = new Compressor(image, {
            quality: 0.5,
            success: (compressedResult) => {
                const reader = new FileReader()
                reader.onload = () => {
                    resolve(reader.result)
                }
                reader.readAsDataURL(compressedResult)
            }
        })
        console.log(_compressor)
    })
}
